import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { getUserFullName } from 'utils';
import usePastTime from 'hooks/usePastTime';

import './DefaultsSettingsTag.styles.scss';

type DefaultsSettingsTagProps = {
  className?: string;
  defaultsSettingsSetupAt?: Date;
  defaultsSettingsSetupBy?: { firstName: string; lastName?: string };
};

const DefaultsSettingsTag: React.FC<DefaultsSettingsTagProps> = (props) => {
  const { className, defaultsSettingsSetupAt, defaultsSettingsSetupBy } = props;

  const classes = classNames('defaults-settings-tag', className);

  const { t } = useTranslation();

  const pastTime = usePastTime();

  return (
    <div className={classes}>
      <div className={classNames({ default: !defaultsSettingsSetupAt })}>
        {t(
          !defaultsSettingsSetupAt
            ? 'customisedForThisDataRoom'
            : 'usingOrganisationDefaults',
        )}
      </div>

      {!!defaultsSettingsSetupBy && (
        <p>
          <span>
            {t('lastUpdatedBy', {
              fullName: getUserFullName(
                defaultsSettingsSetupBy.firstName,
                defaultsSettingsSetupBy.lastName,
              ),
            })}
          </span>
          <span>{pastTime(defaultsSettingsSetupAt)}</span>
        </p>
      )}
    </div>
  );
};

export default DefaultsSettingsTag;
